import {put, takeEvery, call} from 'redux-saga/effects';
import {
    FEEDBACK_QUALITY_ADD,
    FEEDBACK_QUALITY_ADD_REQUEST,
    FEEDBACK_QUALITY_ADD_SUCCESS,
    FEEDBACK_QUALITY_ADD_FAILURE
} from '../constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';

function* qualityFeedbackAdd(action: any) {
    try {
        yield put({type: FEEDBACK_QUALITY_ADD_REQUEST});
        const data = yield call(Api.fetch, {
            endpoint: `relations?profileId=${action.payload}`,
            method: ApiMethods.POST
        });
        yield put({type: FEEDBACK_QUALITY_ADD_SUCCESS, profile: data.responseData});
    } catch (e) {
        yield put({type: FEEDBACK_QUALITY_ADD_FAILURE, error: e});
    }
}

function* qualityFeedbackSagaAdd() {
    yield takeEvery(FEEDBACK_QUALITY_ADD, qualityFeedbackAdd);
}

export default qualityFeedbackSagaAdd;
